import React, { useState } from "react";
import MonoButton from "./MonoButton";

const ForgotPasswordModal = ({ onClose }) => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    try {
      const res = await fetch("https://www.denisbitter.de/stage01/api/forgot_password.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await res.json();
      if (data.success) {
        setSent(true);
        setMessage("E-Mail wurde gesendet. Bitte prüfe dein Postfach.");
      } else {
        setMessage(data.message || "Fehler beim Senden.");
      }
    } catch (err) {
      setMessage("Serverfehler. Bitte später erneut versuchen.");
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-gray-50 rounded-lg p-6 w-full max-w-md shadow-xl font-mono text-center">
        <h2 className="text-xs font-semibold mb-4">Passwort zurücksetzen</h2>
        <p className="text-xs mb-4">
          Bitte gib deine E-Mail-Adresse ein, um einen Link zum Zurücksetzen deines Passworts zu erhalten.
        </p>

        {sent ? (
          <p className="text-brand">{message}</p>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <input
              type="email"
              name="email"
              placeholder="Deine E-Mail-Adresse"
              className="w-full border px-3 py-2 rounded text-center text-xs focus:outline-none focus:ring-1 focus:ring-gray-900"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            {message && <p className="text-red-500 text-xs">{message}</p>}
            <MonoButton type="submit" className="w-full text-xs">Zurücksetzen senden</MonoButton>
          </form>
        )}

        <MonoButton
          className="mt-4 text-xs text-gray-500 underline text-center w-full"
          onClick={onClose}
        >
          Schliessen
        </MonoButton>
      </div>
    </div>
  );
};

export default ForgotPasswordModal;
